import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { c as cl } from './clsx.m.js';
import { a as createLogger, d as isNumber, e as emitEvent, l as logDeprecatedEventOnce } from './utils.js';
import { d as defineCustomElement$5 } from './cl-icon2.js';
import { d as defineCustomElement$4 } from './cl-icon-button2.js';
import { d as defineCustomElement$3 } from './cl-scroll-wrapper2.js';
import { d as defineCustomElement$2 } from './cl-typography2.js';

// Constants
const component = 'cl-date-picker';
var DatePickerWeekDays;
(function (DatePickerWeekDays) {
  DatePickerWeekDays[DatePickerWeekDays["Mon"] = 0] = "Mon";
  DatePickerWeekDays[DatePickerWeekDays["Tue"] = 1] = "Tue";
  DatePickerWeekDays[DatePickerWeekDays["Wed"] = 2] = "Wed";
  DatePickerWeekDays[DatePickerWeekDays["Thu"] = 3] = "Thu";
  DatePickerWeekDays[DatePickerWeekDays["Fri"] = 4] = "Fri";
  DatePickerWeekDays[DatePickerWeekDays["Sat"] = 5] = "Sat";
  DatePickerWeekDays[DatePickerWeekDays["Sun"] = 6] = "Sun";
})(DatePickerWeekDays || (DatePickerWeekDays = {}));

const clDatePickerCss = ".sc-cl-date-picker-h{--date-picker-z-index:var(--z-index-6);background-color:rgba(var(--color-neutral-main));border-radius:var(--border-radius-large);box-shadow:var(--elevation-2);display:none;flex-direction:column;font-variant-numeric:lining-nums;height:calc(var(--spacing-eighth) * 321);overflow:hidden;padding:var(--spacing-3) 0;position:relative;width:calc(var(--spacing-quarter) * 185);z-index:var(--date-picker-z-index)}.sc-cl-date-picker-h,.sc-cl-date-picker-h *.sc-cl-date-picker,.sc-cl-date-picker-h *.sc-cl-date-picker::before,.sc-cl-date-picker-h *.sc-cl-date-picker::after,.sc-cl-date-picker-h .sc-cl-date-picker-s>*,.sc-cl-date-picker-h .sc-cl-date-picker-s *,.sc-cl-date-picker-h .sc-cl-date-picker-s *::before,.sc-cl-date-picker-h .sc-cl-date-picker-s *::after{box-sizing:border-box}.sc-cl-date-picker-h .day-selector.sc-cl-date-picker,.sc-cl-date-picker-h .month-selector__wrapper.sc-cl-date-picker{display:none}.sc-cl-date-picker-h .header.sc-cl-date-picker{align-items:center;background-color:inherit;display:flex;height:var(--spacing-3);justify-content:space-between;margin-bottom:var(--spacing-2);padding:0 var(--spacing-2);position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}.sc-cl-date-picker-h .header.sc-cl-date-picker cl-icon.sc-cl-date-picker{color:rgba(var(--color-brand-600));cursor:pointer;height:var(--spacing-3);width:var(--spacing-3)}.sc-cl-date-picker-h .header.sc-cl-date-picker cl-icon.header__chevron--disabled.sc-cl-date-picker{color:rgba(var(--color-neutral-300));cursor:not-allowed}.sc-cl-date-picker-h .header__middle.sc-cl-date-picker{align-items:center;display:flex;flex-direction:row}.sc-cl-date-picker-h .header__middle__today.sc-cl-date-picker{cursor:pointer;margin-right:var(--spacing-1)}.sc-cl-date-picker-h .header__middle__month-preview.sc-cl-date-picker{cursor:pointer;display:flex;flex:auto;justify-content:flex-start;line-height:var(--spacing-3);margin:0 var(--spacing-1) 0 0;position:relative;text-align:center}.sc-cl-date-picker-h .header__middle__year-preview.sc-cl-date-picker{cursor:pointer;display:flex;flex:auto;justify-content:flex-start;line-height:var(--spacing-3);margin:0;position:relative;text-align:center}.sc-cl-date-picker-h .header__chevron.sc-cl-date-picker:hover{cursor:pointer}.sc-cl-date-picker-h .header__toggle-dropdown.sc-cl-date-picker{display:flex;flex:auto;justify-content:flex-end;padding-right:var(--spacing-2)}.sc-cl-date-picker-h .day-selector.sc-cl-date-picker{border-spacing:none;margin:0 var(--spacing-2);padding-bottom:var(--spacing-3);-webkit-user-select:none;-moz-user-select:none;user-select:none}.sc-cl-date-picker-h .day-selector__day-letters.sc-cl-date-picker{display:flex;justify-content:space-around;padding-bottom:var(--spacing-1)}.sc-cl-date-picker-h .day-selector__day-letters__letter.sc-cl-date-picker{display:flex;justify-content:center;margin:0;width:100%}.sc-cl-date-picker-h .day-selector__week-row.sc-cl-date-picker{display:block}.sc-cl-date-picker-h .day-selector__week-row.sc-cl-date-picker td.sc-cl-date-picker{align-content:center;border-radius:100%;display:inline-flex;justify-content:center;width:14.2857142857%}.sc-cl-date-picker-h .day-selector__week-row__day-container.sc-cl-date-picker{height:var(--spacing-4);position:relative;width:var(--spacing-4)}.sc-cl-date-picker-h .day-selector__week-row__day-container__background.sc-cl-date-picker{background-color:rgba(var(--color-brand-100));height:100%;left:50%;position:absolute;width:calc(100% + var(--spacing-2) + var(--spacing-quarter))}.sc-cl-date-picker-h .day-selector__week-row__day-container__background--left-edge.sc-cl-date-picker{left:0;width:calc(150% + var(--spacing-2) + var(--spacing-quarter))}.sc-cl-date-picker-h .day-selector__week-row__day-container__background--left-edge--start.sc-cl-date-picker{left:50%;width:50%}.sc-cl-date-picker-h .day-selector__week-row__day-container__background--left-edge--end.sc-cl-date-picker{left:0;width:var(--spacing-2)}.sc-cl-date-picker-h .day-selector__week-row__day-container__background--right-edge.sc-cl-date-picker{left:0;width:100%}.sc-cl-date-picker-h .day-selector__week-row__day-container__day.sc-cl-date-picker{border-radius:var(--border-radius-circle);cursor:pointer;height:100%;position:relative;width:100%}.sc-cl-date-picker-h .day-selector__week-row__day-container__day.sc-cl-date-picker::after{border-radius:inherit;content:\"\";height:inherit;position:absolute;width:inherit}.sc-cl-date-picker-h .day-selector__week-row__day-container__day.sc-cl-date-picker:hover{background-color:rgba(var(--color-brand-main), var(--opacity-1))}.sc-cl-date-picker-h .day-selector__week-row__day-container__day.sc-cl-date-picker cl-typography.sc-cl-date-picker{left:50%;line-height:normal;margin:0;position:absolute;top:50%;transform:translate(-50%, -50%)}.sc-cl-date-picker-h .day-selector__week-row__day-container__day--today.sc-cl-date-picker{border:var(--border-width) solid rgba(var(--color-brand-600));box-sizing:border-box}.sc-cl-date-picker-h .day-selector__week-row__day-container__day--selected.sc-cl-date-picker{background-color:rgba(var(--color-brand-main));color:rgba(var(--font-color-onbrand-default))}.sc-cl-date-picker-h .day-selector__week-row__day-container__day--selected.sc-cl-date-picker cl-typography.sc-cl-date-picker{--typography-color:rgba(var(--font-color-onbrand-default))}.sc-cl-date-picker-h .day-selector__week-row__day-container__day--selected.sc-cl-date-picker:hover{background-color:rgba(var(--color-brand-main))}.sc-cl-date-picker-h .day-selector__week-row__day-container__day--disabled.sc-cl-date-picker{background-color:rgba(var(--color-neutral-main));cursor:not-allowed}.sc-cl-date-picker-h .day-selector__week-row__day-container__day--disabled.sc-cl-date-picker cl-typography.sc-cl-date-picker{--typography-color:rgba(var(--font-color-onlight-muted))}.sc-cl-date-picker-h .day-selector__week-row__day-container__day--disabled.sc-cl-date-picker:hover{background-color:rgba(var(--color-neutral-main))}.sc-cl-date-picker-h .month-selector.sc-cl-date-picker{border-spacing:none;display:grid;gap:var(--spacing-2) 0;grid-template-columns:repeat(3, minmax(0, 1fr));height:-moz-fit-content;height:fit-content;margin:var(--spacing-4) var(--spacing-2);-webkit-user-select:none;-moz-user-select:none;user-select:none}.sc-cl-date-picker-h .month-selector__wrapper.sc-cl-date-picker{height:100%;padding:0 var(--spacing-1);position:relative}.sc-cl-date-picker-h .month-selector__wrapper.sc-cl-date-picker cl-scroll-wrapper.sc-cl-date-picker{--wrapper-max-height:calc(100% - var(--spacing-2))}.sc-cl-date-picker-h .month-selector__month.sc-cl-date-picker{align-content:center;display:flex;justify-content:center;width:100%}.sc-cl-date-picker-h .month-selector__month.sc-cl-date-picker cl-typography.sc-cl-date-picker{--typography-color:rgba(var(--font-color-onlight-brand));border:var(--spacing-quarter) solid transparent;border-radius:var(--border-radius-interactive-small);cursor:pointer;font-size:var(--font-size-body-1);line-height:var(--spacing-3);margin:0;padding:var(--spacing-quarter) var(--spacing-1);width:-moz-min-content;width:min-content}.sc-cl-date-picker-h .month-selector__month.sc-cl-date-picker:not(.month-selector__month--disabled) cl-typography.sc-cl-date-picker:hover{background-color:rgba(var(--color-brand-100))}.sc-cl-date-picker-h .month-selector__month--current.sc-cl-date-picker cl-typography.sc-cl-date-picker{border-color:rgba(var(--color-brand-main))}.sc-cl-date-picker-h .month-selector__month--disabled.sc-cl-date-picker cl-typography.sc-cl-date-picker{--typography-color:rgba(var(--font-color-onlight-muted));cursor:not-allowed}.sc-cl-date-picker-h .month-selector__month--selected.sc-cl-date-picker:not(.month-selector__month--disabled) cl-typography.sc-cl-date-picker{--typography-color:rgb(var(--font-color-onbrand-default));background-color:rgba(var(--color-brand-main))}.sc-cl-date-picker-h .month-selector__month--selected.sc-cl-date-picker:not(.month-selector__month--disabled) cl-typography.sc-cl-date-picker:hover{--typography-color:rgba(var(--font-color-onlight-brand));background-color:rgba(var(--color-brand-100));border-color:rgba(var(--color-brand-main))}.sc-cl-date-picker-h .month-selector__month--selected.sc-cl-date-picker:not(.month-selector__month--disabled) cl-typography.sc-cl-date-picker:not(:hover){color:rgba(var(--color-neutral-50))}.sc-cl-date-picker-h .year-selector.sc-cl-date-picker{border-spacing:none;display:grid;gap:var(--spacing-half) var(--spacing-1);grid-template-columns:repeat(5, minmax(0, 1fr));height:-moz-fit-content;height:fit-content;margin-left:var(--spacing-2);padding:var(--spacing-1) 0;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;visibility:hidden}.sc-cl-date-picker-h .year-selector--previous.sc-cl-date-picker{position:relative;width:calc(100% - var(--spacing-2) * 2)}.sc-cl-date-picker-h .year-selector__wrapper.sc-cl-date-picker{height:100%;padding:0 var(--spacing-1);position:relative}.sc-cl-date-picker-h .year-selector__wrapper.sc-cl-date-picker cl-scroll-wrapper.sc-cl-date-picker{--wrapper-max-height:calc(100% - var(--spacing-2))}.sc-cl-date-picker-h .year-selector__year.sc-cl-date-picker{align-content:center;display:flex;justify-content:center;position:relative;width:100%}.sc-cl-date-picker-h .year-selector__year.sc-cl-date-picker cl-typography.sc-cl-date-picker{border:var(--spacing-quarter) solid transparent;border-radius:var(--border-radius-interactive-small);cursor:pointer;line-height:var(--spacing-3);margin:0;padding:var(--spacing-quarter) var(--spacing-1);width:-moz-min-content;width:min-content}.sc-cl-date-picker-h .year-selector__year.sc-cl-date-picker cl-typography.sc-cl-date-picker:not(.muted){color:rgba(var(--color-brand-main))}.sc-cl-date-picker-h .year-selector__year.sc-cl-date-picker cl-typography.sc-cl-date-picker:not(.muted):hover{--typography-color:rgba(var(--font-color-onbrand-default));background-color:rgba(var(--color-brand-100));border-color:transparent}.sc-cl-date-picker-h .year-selector__year--today.sc-cl-date-picker cl-typography.sc-cl-date-picker{border-color:rgba(var(--color-brand-main))}.sc-cl-date-picker-h .year-selector__year--selected.sc-cl-date-picker cl-typography.sc-cl-date-picker{--typography-color:rgba(var(--font-color-onbrand-default));background-color:rgba(var(--color-brand-main))}.sc-cl-date-picker-h .year-selector__year--selected.sc-cl-date-picker cl-typography.sc-cl-date-picker:hover{background-color:rgba(var(--color-brand-100));border-color:rgba(var(--color-brand-main))}.sc-cl-date-picker-h .year-selector__year--selected.sc-cl-date-picker cl-typography.sc-cl-date-picker:not(:hover){color:rgba(var(--color-neutral-50))}.sc-cl-date-picker-h .year-selector__year__background.sc-cl-date-picker{background-color:rgba(var(--color-brand-100));height:var(--spacing-4);left:50%;position:absolute;width:var(--spacing-8);z-index:-1}.sc-cl-date-picker-h .year-selector__year__background--left-edge.sc-cl-date-picker{left:0;width:calc(150% + var(--spacing-2) + var(--spacing-quarter))}.sc-cl-date-picker-h .year-selector__year__background--left-edge--start.sc-cl-date-picker{left:50%;width:150%}.sc-cl-date-picker-h .year-selector__year__background--left-edge--end.sc-cl-date-picker{left:0;width:var(--spacing-2)}.sc-cl-date-picker-h .year-selector__year__background--right-edge.sc-cl-date-picker{right:0;width:50%}.date-picker--open.sc-cl-date-picker-h{display:block}.date-picker--page-days.sc-cl-date-picker-h .day-selector.sc-cl-date-picker{display:block}.date-picker--page-months.sc-cl-date-picker-h .month-selector__wrapper.sc-cl-date-picker{display:block}.date-picker--page-years.sc-cl-date-picker-h .year-selector.sc-cl-date-picker{visibility:visible}";

const ClDatePicker$1 = /*@__PURE__*/ proxyCustomElement(class ClDatePicker extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.clChange = createEvent(this, "clChange", 7);
    this.change = createEvent(this, "dateChange", 7);
    /**
     * Object containing custom consoleLogger functions.
     */
    this.logger = createLogger(component);
    this.dayCounter = -1;
    this.dayLetters = [];
    this.monthNames = [];
    this.shouldUpdateScrollHeight = true;
    this.weekdayBlacklist = [];
    this.dateBlacklist = [];
    this.dateWhitelist = [];
    /**
     * Handles a click on a day in the date-picker.
     */
    this.handleDayClick = (event) => {
      const path = event.composedPath();
      const target = (path[0].tagName === 'DIV' ? path[0].childNodes[0] : path[0]);
      const dayNumber = parseInt(target.innerText, 10);
      const monthDays = new Date(this.year, this.month + 1, 0).getDate();
      if (!isNumber(dayNumber) || dayNumber < 1 || dayNumber > monthDays) {
        return;
      }
      let nextDate = [this.year, this.month];
      const parentElement = target.parentElement;
      if (parentElement) {
        if (parentElement.classList.contains('day-selector__week-row__day-container__day--prev')) {
          nextDate = this.month === 0 ? [this.year - 1, 11] : [this.year, this.month - 1];
        }
        else if (parentElement.classList.contains('day-selector__week-row__day-container__day--next')) {
          nextDate = this.month === 11 ? [this.year + 1, 0] : [this.year, this.month + 1];
        }
      }
      const date = new Date(nextDate[0], nextDate[1], dayNumber);
      if (!this.range) {
        this.selected = [date, null];
        emitEvent(this, 'clChange', { component, originalEvent: event, startDate: this.selected[0] }, { startDate: this.selected[0], endDate: null });
        return;
      }
      if (this.selected[0] === null && this.selected[1] === null) {
        this.selected = [date, null];
        return;
      }
      if (this.selected[0]) {
        if (this.selected[0].getTime() === date.getTime()) {
          this.selected = [this.selected[1], null];
          return;
        }
        if (this.selected[1] === null) {
          if (date.getTime() > this.selected[0].getTime()) {
            this.selected = [this.selected[0], date];
            emitEvent(this, 'clChange', Object.assign({ component, originalEvent: event, startDate: this.selected[0] }, (this.selected[1] ? { endDate: this.selected[1] } : {})), { startDate: this.selected[0], endDate: this.selected[1] });
            return;
          }
          if (date.getTime() < this.selected[0].getTime()) {
            this.selected = [date, this.selected[0]];
            emitEvent(this, 'clChange', Object.assign({ component, originalEvent: event, startDate: this.selected[0] }, (this.selected[1] ? { endDate: this.selected[1] } : {})), { startDate: this.selected[0], endDate: this.selected[1] });
            return;
          }
        }
      }
      if (this.selected[1]) {
        if (this.selected[1].getTime() === date.getTime()) {
          this.selected = [this.selected[0], null];
        }
        else {
          this.selected = [date, null];
        }
      }
    };
    /**
     * Takes a string input and capitalises the first letter, which decapitalising the latter letters.
     */
    this.capitalizeString = (string) => !string ? string : string[0].toUpperCase() + string.substring(1).toLowerCase();
    /**
     * Determines if and in what way the given date is selected.
     *
     *
     * Possible output
     * null: `date` is not selected.
     * start_range: `date` is the start date of a selected range.
     * in_range: `date` is within a selected range, but it is not the start or end date of the range.
     * end_range: `date` is the end date of a selected range or `date` is the only selected date.
     */
    this.getSelectionType = (date) => {
      switch (true) {
        case this.selected[0] && date.setHours(0, 0, 0, 0) === this.selected[0].setHours(0, 0, 0, 0): {
          if (this.selected[1])
            return 'start_range';
          return 'no_range';
        }
        case this.selected[0] instanceof Date &&
          this.selected[1] instanceof Date &&
          date.getTime() > this.selected[0].getTime() &&
          date.getTime() < this.selected[1].getTime():
          return 'in_range';
        case this.selected[1] instanceof Date: {
          if (date.getTime() === this.selected[1].getTime()) {
            return 'end_range';
          }
          if (this.selected[0] &&
            date.getTime() > this.selected[0].getTime() &&
            date.getTime() < this.selected[1].getTime()) {
            return 'in_range';
          }
          return null;
        }
        default:
          return null;
      }
    };
    /**
     * Calculates the days to be displayed for the set month and year and returns them in an array.
     */
    this.getDisplayDays = () => {
      const monthDays = new Date(this.year, this.month + 1, 0).getDate();
      const previousMonthDays = new Date(this.year, this.month, 0).getDate();
      const firstDay = new Date(this.year, this.month, 1);
      const lastDay = new Date(this.year, this.month, monthDays);
      const firstDayNumber = firstDay.getDay();
      const lastDayNumber = lastDay.getDay();
      let startDayPrevMonth;
      switch (firstDayNumber) {
        case 0:
          startDayPrevMonth = previousMonthDays - 5;
          break;
        case 1:
          startDayPrevMonth = null;
          break;
        default:
          startDayPrevMonth = previousMonthDays - firstDayNumber + 2;
      }
      const days = [];
      if (startDayPrevMonth !== null) {
        for (let i = startDayPrevMonth; i <= previousMonthDays; i += 1) {
          days.push({ day: i, type: 'previous' });
        }
      }
      for (let i = 1; i <= monthDays; i += 1) {
        days.push({ day: i, type: 'current' });
      }
      const rows = days.length / 7;
      const endDayNextMonth = rows >= 5 ? 7 - lastDayNumber : 7 - lastDayNumber + 7;
      for (let i = 1; i <= endDayNextMonth; i += 1) {
        days.push({ day: i, type: 'next' });
      }
      if (this.startSunday) {
        const day = days[0].day > 1 ? days[0].day - 1 : previousMonthDays;
        days.pop();
        days.unshift({ day, type: 'previous' });
      }
      return days;
    };
    /**
     * Returns the day selector component, the overview that shows all the days in the currently selected month.
     */
    this.getDaySelector = () => {
      const days = this.getDisplayDays();
      const weekRows = Array.from(Array(6).keys());
      return (h("table", { class: 'day-selector' }, h("tr", { class: 'day-selector__day-letters' }, this.dayLetters.map(day => (h("td", { key: day, class: 'day-selector__day-letters__letter' }, h("cl-typography", { variant: 'subtitle-2' }, day))))), weekRows.map(week => (h("tr", { key: week, class: 'day-selector__week-row' }, days.slice(week * 7, week * 7 + 7).map(({ day, type }) => {
        let currentDate;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.dayCounter = (this.dayCounter + 1) % 7;
        if (type === 'current') {
          currentDate = new Date(this.year, this.month, day);
        }
        else if (type === 'previous') {
          currentDate =
            this.month === 0 ? new Date(this.year - 1, 11, day) : new Date(this.year, this.month - 1, day);
        }
        else {
          currentDate =
            this.month === 11 ? new Date(this.year + 1, 0, day) : new Date(this.year, this.month + 1, day);
        }
        currentDate.setHours(0, 0, 0, 0);
        const selectionType = this.getSelectionType(currentDate) || '';
        const dayNumber = currentDate.getDay();
        const weekDay = dayNumber > 0 && dayNumber < 6;
        const selectable = (!this.minDate || (this.minDate && currentDate >= this.minDateObj)) &&
          (!this.maxDate || (this.maxDate && currentDate <= this.maxDateObj)) &&
          (!this.noWeekend || (this.noWeekend && weekDay)) &&
          !this.disableBy.dayBlacklist(this.dayCounter) &&
          !this.disableBy.dateBlacklist(currentDate) &&
          !this.disableBy.dateWhitelist(currentDate) &&
          !this.disableBy.customRule(currentDate);
        const isSelected = ['start_range', 'end_range', 'no_range'].includes(selectionType);
        return (h("td", { key: day }, h("div", { class: 'day-selector__week-row__day-container ' }, (selectionType === 'start_range' ||
          selectionType === 'in_range' ||
          (selectionType === 'end_range' && this.dayCounter === 0)) && (h("div", { class: cl('day-selector__week-row__day-container__background', {
            'day-selector__week-row__day-container__background--left-edge': this.dayCounter === 0 && selectionType === 'in_range',
            'day-selector__week-row__day-container__background--left-edge--end': this.dayCounter === 0 && selectionType === 'end_range',
            'day-selector__week-row__day-container__background--left-edge--start': this.dayCounter === 6 && selectionType === 'start_range',
            'day-selector__week-row__day-container__background--right-edge': this.dayCounter === 6 && selectionType === 'in_range',
          }) })), h("div", { class: cl('day-selector__week-row__day-container__day', {
            'day-selector__week-row__day-container__day--prev': type === 'previous',
            'day-selector__week-row__day-container__day--next': type === 'next',
            'day-selector__week-row__day-container__day--today': today.getTime() === currentDate.getTime(),
            'day-selector__week-row__day-container__day--disabled': !selectable,
            'day-selector__week-row__day-container__day--selected': isSelected,
          }), onClick: selectable ? this.handleDayClick : undefined }, h("cl-typography", Object.assign({ surface: selectable && isSelected ? 'primary' : 'light', variant: 'button' }, (((selectable && type !== 'current') || (this.noWeekend && !weekDay)) && {
          type: 'disabled',
        })), day)))));
      }))))));
    };
    /**
     * Returns the first letter of the seven days of the week in the specified locale.
     */
    this.getDayLetters = () => {
      const date = new Date();
      date.setDate(date.getDate() - date.getDay());
      const start = date.getDate();
      let days = [...new Array(7)].map((_, i) => {
        date.setDate(start + i);
        return new Intl.DateTimeFormat(this.locale, { weekday: 'narrow' }).format(date);
      });
      if (!this.startSunday) {
        days = [...days.slice(1), ...days.slice(0, 1)];
      }
      return days;
    };
    /**
     * Returns the names of the twelve months in the specified locale.
     */
    this.getMonthNames = () => {
      const date = new Date('1 Jan 2000');
      return [...new Array(12)].map((_, i) => {
        date.setMonth(i);
        return this.capitalizeString(new Intl.DateTimeFormat(this.locale, { month: 'long' }).format(date));
      });
    };
    /**
     * A function that sets the year scroll wrapper scroll height to the height of
     * the current year.
     */
    this.setScrollWrapperScrollHeight = () => {
      if (this.scrollWrapper) {
        this.scrollWrapper.scrollTop = 0;
        const scrollOffset = this.thisYearElement ? this.thisYearElement.offsetTop : 0;
        this.scrollWrapper.scrollTop = scrollOffset;
      }
    };
    /**
     * A function that check if month is disabled by provided date blacklist.
     */
    this.isUnselectableMonth = (dates, index) => {
      if (dates.length === 0)
        return false;
      const yearAndMonth = [...new Set(dates.map(d => `${d.getFullYear()}-${d.getMonth()}`))];
      const unselectableMonths = yearAndMonth.reduce((result, item) => {
        const [itemYear, itemMonth] = item.split('-').map(Number);
        const totalDaysInMonth = new Date(itemYear, itemMonth - 1, 0).getDate();
        const selectedDaysInMonth = dates.filter(d => d.getFullYear() === itemYear && d.getMonth() === itemMonth);
        if (selectedDaysInMonth.length === totalDaysInMonth) {
          result.push(itemMonth);
        }
        return result;
      }, []);
      return unselectableMonths.includes(index);
    };
    /**
     * A function that check if month is disabled by provided date whitelist.
     */
    this.isSelectableMonth = (dates, month) => {
      if (dates.length === 0)
        return true;
      return [...new Set(dates.map(d => d.getMonth()))].includes(month);
    };
    /**
     * A function that resets the displayed month and year to today's month and year.
     */
    this.resetToToday = () => {
      this.month = new Date().getMonth();
      this.year = new Date().getFullYear();
      this.shownPage = 'days';
    };
    /**
     * A function that decreases the displayed month by one.
     */
    this.decreaseMonth = () => {
      const previousMonth = this.month - 1;
      this.month = previousMonth === -1 ? 11 : previousMonth;
      if (previousMonth === -1) {
        this.year -= 1;
      }
    };
    /**
     * A function that increases the displayed month by one.
     */
    this.increaseMonth = () => {
      const nextMonth = this.month + 1;
      this.month = nextMonth === 12 ? 0 : nextMonth;
      if (nextMonth === 12) {
        this.year += 1;
      }
    };
    /**
     * A function that hides the day picker or year picker and shows the month picker.
     */
    this.toggleMonths = () => {
      if (this.shownPage !== 'months') {
        this.shownPage = 'months';
      }
      else {
        this.shownPage = 'days';
      }
    };
    /**
     * A function that hides the day picker or month picker and shows the year picker.
     */
    this.toggleYears = () => {
      if (this.shownPage !== 'years') {
        this.shownPage = 'years';
      }
      else {
        this.shownPage = 'days';
      }
    };
    /**
     * returns a div with the header of the date picker in the localised language.
     */
    this.getHeader = () => {
      const monthName = this.capitalizeString(this.monthNames[this.month]);
      const previousMonth = this.month === 0 ? 11 : this.month - 1;
      const previousYear = this.month === 0 ? this.year - 1 : this.year;
      const nextMonth = this.month === 11 ? 0 : this.month + 1;
      const nextYear = this.month === 11 ? this.year + 1 : this.year;
      const previousIsDisabled = (this.getLowestYear() === previousYear && this.getLowestMonth() > previousMonth) ||
        this.getLowestYear() > previousYear;
      const nextIsDisabled = (this.getHighestYear() === nextYear && this.getHighestMonth() < nextMonth) || this.getHighestYear() < nextYear;
      return (h("div", { class: 'header' }, h("cl-icon-button", Object.assign({ class: cl('header__chevron header__navigation--left', {
          'header__chevron--disabled': previousIsDisabled,
        }), "icon-name": 'navigation--chevron--left', variant: 'tertiary', selected: true }, (!previousIsDisabled && { onClick: this.decreaseMonth }))), h("div", { class: 'header__middle' }, h("cl-icon-button", { class: 'header__middle__today', "icon-name": 'navigation--current', variant: 'tertiary', selected: true, onClick: this.resetToToday }), h("cl-typography", { class: 'header__middle__month-preview', variant: 'h6', onClick: this.toggleMonths }, monthName), h("cl-typography", { class: 'header__middle__year-preview', variant: 'h6', onClick: this.toggleYears }, this.year)), h("cl-icon-button", Object.assign({ class: cl('header__chevron header__navigation--right', {
          'header__chevron--disabled': nextIsDisabled,
        }), "icon-name": 'navigation--chevron--right', variant: 'tertiary', selected: true }, (!nextIsDisabled && { onClick: this.increaseMonth })))));
    };
    /**
     * Get the text content of the element, excluding the comments
     */
    this.getContent = (event) => {
      const htmlString = event.target.innerHTML;
      // Create a temporary element to parse the HTML string
      const tempElement = document.createElement('div');
      tempElement.innerHTML = htmlString;
      // Get the text content of the element, excluding the comments
      const textContent = Array.from(tempElement.childNodes)
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent)
        .join('');
      return textContent;
    };
    /**
     * Sets the month based on the element that is clicked.
     */
    this.setMonth = (event) => {
      this.month = this.monthNames.indexOf(this.capitalizeString(this.getContent(event)));
      this.shownPage = 'days';
    };
    /**
     * Calculates whether the given month should be disabled based on the current year.
     */
    this.isDisabledMonth = (month) => (this.getLowestYear() === this.year && this.getLowestMonth() > month) ||
      this.getLowestYear() > this.year ||
      (this.getHighestYear() === this.year && this.getHighestMonth() < month) ||
      this.getHighestYear() < this.year ||
      !this.isSelectableMonth(this.dateWhitelist, month) ||
      this.isUnselectableMonth(this.dateBlacklist, month);
    /**
     * Returns the lowest selectable month of the lowest selectable year.
     */
    this.getLowestMonth = () => this.getDateBoundary(this.minDate) !== null ? this.getDateBoundary(this.minDate).getMonth() : 0;
    /**
     * Returns the highest selectable month of the highest selectable year.
     */
    this.getHighestMonth = () => this.getDateBoundary(this.maxDate) !== null ? this.getDateBoundary(this.maxDate).getMonth() : 11;
    /**
     * returns a div with all the months of the year in the localised language.
     */
    this.getMonthSelector = () => (h("div", { class: 'month-selector__wrapper' }, h("cl-scroll-wrapper", { ref: el => {
        this.scrollWrapper = el;
      }, "thumb-only": true }, h("div", { class: 'month-selector' }, this.monthNames.map((month, index) => (h("div", { key: month, class: cl('month-selector__month', {
        'month-selector__month--disabled': this.isDisabledMonth(index),
        'month-selector__month--current': index === new Date().getMonth(),
        'month-selector__month--selected': this.selected[0] && index === this.selected[0].getMonth() && !this.range,
      }) }, h("cl-typography", Object.assign({ type: 'primary' }, (!this.isDisabledMonth(index) ? { onClick: this.setMonth } : { type: 'disabled' })), this.capitalizeString(month)))))))));
    /**
     * Sets the year based on the element that is clicked.
     */
    this.setYear = (event) => {
      this.year = Number.parseInt(this.getContent(event), 10);
      this.shownPage = 'days';
    };
    /**
     * Calculates and returns the lowest selectable year based on the given minDate attribute.
     */
    this.getLowestYear = () => this.getDateBoundary(this.minDate) !== null ? this.getDateBoundary(this.minDate).getFullYear() : 1900;
    /**
     * Calculates and returns the highest selectable year based on the given maxDate attribute.
     */
    this.getHighestYear = () => this.getDateBoundary(this.maxDate) !== null ? this.getDateBoundary(this.maxDate).getFullYear() : 2150;
    /**
     * Calculates which years to show and returns a scroll wrapper with those years in it.
     */
    this.getYearSelector = () => {
      const years = [];
      const lowestYear = this.getLowestYear();
      const highestYear = this.getHighestYear();
      const offset = lowestYear % 5;
      for (let year = lowestYear; year <= highestYear; year += 1) {
        years.push(year);
      }
      return (h("div", { class: 'year-selector__wrapper' }, h("cl-scroll-wrapper", { ref: el => {
          this.scrollWrapper = el;
        }, "thumb-only": true }, h("div", { class: 'year-selector' }, years.map(year => (h("div", null, h("div", { key: year, ref: el => {
          if (year === new Date().getFullYear())
            this.thisYearElement = el;
        }, class: cl('year-selector__year', {
          'year-selector__year--today': year === new Date().getFullYear(),
          'year-selector__year--selected': !!((this.selected[0] && year === this.selected[0].getFullYear()) ||
            (this.selected[1] && year === this.selected[1].getFullYear())),
        }) }, this.selected[0] &&
        this.selected[1] &&
        this.selected[0].getFullYear() <= year &&
        (this.selected[1].getFullYear() > year ||
          (this.selected[1].getFullYear() === year && (year - offset) % 5 === 0)) && (h("div", { class: cl('year-selector__year__background', {
          'year-selector__year__background--left-edge': (year - offset) % 5 === 0,
          'year-selector__year__background--left-edge--end': (year - offset) % 5 === 0 && this.selected[1].getFullYear() === year,
          'year-selector__year__background--left-edge--start': (year - offset) % 5 === 0 && this.selected[0].getFullYear() === year,
          'year-selector__year__background--right-edge': (year - offset) % 5 === 4 && this.selected[1].getFullYear() > year,
        }) })), h("cl-typography", { type: 'primary', onClick: this.setYear }, year)))))))));
    };
    this.selected = [null, null];
    this.shownPage = 'days';
    this.disableMethod = null;
    this.autoClose = true;
    this.locale = 'en-UK';
    this.maxDate = '';
    this.minDate = '';
    this.month = new Date().getMonth();
    this.noWeekend = false;
    this.open = false;
    this.range = false;
    this.startSunday = false;
    this.unselectableDaysOfWeek = null;
    this.unselectableDates = '';
    this.selectableDates = '';
    this.year = new Date().getFullYear();
  }
  /**
   * Updates the language-sensitive parts of the Date Picker when the locale gets changed.
   */
  handleLocaleChange() {
    this.dayLetters = this.getDayLetters();
    this.monthNames = this.getMonthNames();
  }
  /**
   * Updates the maxDateObj when the maxDate property is changed.
   */
  updateMaxDate(maxDate) {
    if (maxDate) {
      this.maxDateObj = this.getDateBoundary(maxDate);
      if (this.maxDateObj === null) {
        this.logger.error.attribute.maxDate(`Given invalid value "${maxDate}".`);
        return;
      }
      this.shouldUpdateScrollHeight = true;
    }
  }
  /**
   * Updates the minDateObj when the minDate property is changed.
   */
  updateMinDate(minDate) {
    if (minDate) {
      this.minDateObj = this.getDateBoundary(minDate);
      if (this.minDateObj === null) {
        this.logger.error.attribute.minDate(`Given invalid value "${minDate}".`);
        return;
      }
      this.shouldUpdateScrollHeight = true;
    }
  }
  /**
   * Validates the given value of the month property.
   */
  validateMonth(month) {
    if (!isNumber(month) || month < 0 || month > 11) {
      this.logger.error.attribute.month(`Given invalid value "${month}".`);
      this.month = new Date().getMonth();
    }
  }
  /**
   * Updates the dayLetter array when the startSunday property is changed.
   */
  updateDayLetters() {
    this.dayLetters = this.getDayLetters();
  }
  /**
   * Updates the weekdayBlacklist when the unselectableDaysOfWeek property is changed.
   *
   * Examples:
   *
   * "Mon": each Monday week day is unselectable
   * "Tue, Wed": each Tuesday and Wednesday are unselectable
   * "Mon, Sat": each Monday and Saturday are unselectable
   */
  updateUnselectableDaysOfWeek(days) {
    this.weekdayBlacklist = days ? this.getWeekdayList(days) : [];
  }
  /**
   * Updates the dateBlacklist when the unselectableDates property is changed.
   */
  updateUnselectableDates(dates) {
    this.dateBlacklist = dates ? this.getDateList(dates) : [];
  }
  /**
   * Updates the dateWhitelist when the selectableDates property is changed.
   */
  updateSelectableDates(dates) {
    this.dateWhitelist = dates ? this.getDateList(dates) : [];
  }
  /**
   * Validates the given value of the year property.

   */
  validateYear(year) {
    if (!isNumber(year)) {
      this.logger.error.attribute.year(`Given invalid value "${year}".`);
      this.year = new Date().getFullYear();
    }
  }
  /**
   * Every time the component is connected to the DOM:
   * - Console log deprecation warnings;
   * Set initial variables;
   */
  connectedCallback() {
    logDeprecatedEventOnce(this.logger, 'dateChange', 'clChange');
    this.validateMonth(this.month);
    this.validateYear(this.year);
    this.dayLetters = this.getDayLetters();
    this.monthNames = this.getMonthNames();
    this.updateMinDate(this.minDate);
    this.updateMaxDate(this.maxDate);
    this.updateUnselectableDaysOfWeek(this.unselectableDaysOfWeek);
    this.updateUnselectableDates(this.unselectableDates);
    this.updateSelectableDates(this.selectableDates);
  }
  /**
   * Sets the scroll height of the year scroll wrapper to the correct height post-render.
   */
  componentDidRender() {
    if (this.shouldUpdateScrollHeight) {
      this.setScrollWrapperScrollHeight();
      this.shouldUpdateScrollHeight = false;
    }
  }
  /**
   * Closes the Date Picker if clicked outside the date picker and autoClose is on.
   */
  handleOutsideClick(event) {
    const elements = event.composedPath();
    const isOutsideClick = !elements.includes(this.host);
    if (isOutsideClick && this.autoClose) {
      this.open = false;
    }
  }
  /**
   * Apply custom datepicker date disable filter.
   * @param {FilterCallback} A callback method that returns boolean.
   */
  async disable(callback) {
    this.disableMethod = callback && typeof callback === 'function' ? callback : null;
  }
  /**
   * Returns an array of Date objects
   * @param {string} a dates string eg. 2023-01-01, 2023-01-02
   * @returns {Array<Date>} The boundary Date object list
   */
  getDateList(dates) {
    var _a;
    const dateList = ((_a = dates === null || dates === void 0 ? void 0 : dates.split(',').filter(date => { var _a; return ((_a = String(date)) === null || _a === void 0 ? void 0 : _a.trim().length) > 0; }).map(this.getDateBoundary).filter(date => date !== null)) !== null && _a !== void 0 ? _a : []);
    if (dateList.some(date => date === null)) {
      throw new Error('The specified date is invalid');
    }
    return dateList;
  }
  /**
   * Returns an array of numbers from 0 to 6
   * @param {string} a day name string eg. Mon, Tue, Wed
   * @returns {Array<number>} The list of numbers
   */
  getWeekdayList(days) {
    var _a;
    return ((_a = days === null || days === void 0 ? void 0 : days.split(',').filter(Boolean).map((day) => DatePickerWeekDays[day])) !== null && _a !== void 0 ? _a : []);
  }
  /**
   * Returns an object with date filter methods
   * @returns {object} A list of methods
   */
  get disableBy() {
    return {
      dayBlacklist: (day) => this.weekdayBlacklist.includes(day),
      dateBlacklist: (date) => this.dateBlacklist.some(d => d.getTime() === date.getTime()),
      dateWhitelist: (date) => {
        const dateTimeList = this.dateWhitelist.map(d => d.getTime());
        return dateTimeList.length > 0 && !dateTimeList.includes(date.getTime());
      },
      // apply custom date disable rule
      customRule: (date) => {
        if (this.disableMethod && typeof this.disableMethod === 'function') {
          return this.disableMethod(date);
        }
        return false;
      },
    };
  }
  /**
   * Takes either a modifier string (see minDate and maxDate)
   * and gives you a Date object for when that is. If a Date string
   * (e.g. 11-12-22) is sent through, it will be looped back.
   */
  getDateBoundary(modifier) {
    const dateRegex = new RegExp('(\\+|-)(\\d{1,})(d|m|w|y)', 'g');
    const result = dateRegex.exec(modifier);
    if (result) {
      const [, operator, n, period] = result;
      let day = new Date().getDate();
      let month = new Date().getMonth();
      let year = new Date().getFullYear();
      const num = parseInt(n, 10);
      const amount = period === 'w' ? 7 * num : num;
      switch (period) {
        case 'd':
        case 'w':
          day = operator === '+' ? day + amount : day - amount;
          break;
        case 'm':
          month = operator === '+' ? month + amount : month - amount;
          break;
        case 'y':
          year = operator === '+' ? year + amount : year - amount;
          break;
      }
      return new Date(year, month, day, 0, 0, 0, 0);
    }
    const nextDate = new Date(modifier);
    if (nextDate.toString() !== 'Invalid Date') {
      nextDate.setHours(0, 0, 0, 0);
      return nextDate;
    }
    return null;
  }
  render() {
    const { open } = this;
    return (h(Host, { class: cl(`date-picker date-picker--page-${this.shownPage}`, { 'date-picker--open': open }), shownPage: this.shownPage }, this.getHeader(), this.getDaySelector(), this.getMonthSelector(), this.getYearSelector()));
  }
  get host() { return this; }
  static get watchers() { return {
    "locale": ["handleLocaleChange"],
    "maxDate": ["updateMaxDate"],
    "minDate": ["updateMinDate"],
    "month": ["validateMonth"],
    "startSunday": ["updateDayLetters"],
    "unselectableDaysOfWeek": ["updateUnselectableDaysOfWeek"],
    "unselectableDates": ["updateUnselectableDates"],
    "selectableDates": ["updateSelectableDates"],
    "year": ["validateYear"]
  }; }
  static get style() { return clDatePickerCss; }
}, [2, "cl-date-picker", {
    "autoClose": [4, "auto-close"],
    "locale": [513],
    "maxDate": [1, "max-date"],
    "minDate": [1, "min-date"],
    "month": [1538],
    "noWeekend": [4, "no-weekend"],
    "open": [1540],
    "range": [4],
    "startSunday": [516, "start-sunday"],
    "unselectableDaysOfWeek": [1, "unselectable-days-of-week"],
    "unselectableDates": [1, "unselectable-dates"],
    "selectableDates": [1, "selectable-dates"],
    "year": [1538],
    "selected": [32],
    "shownPage": [32],
    "disableMethod": [32],
    "disable": [64]
  }, [[4, "click", "handleOutsideClick"]]]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["cl-date-picker", "cl-icon", "cl-icon-button", "cl-scroll-wrapper", "cl-typography"];
  components.forEach(tagName => { switch (tagName) {
    case "cl-date-picker":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ClDatePicker$1);
      }
      break;
    case "cl-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$5();
      }
      break;
    case "cl-icon-button":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "cl-scroll-wrapper":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "cl-typography":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const ClDatePicker = ClDatePicker$1;
const defineCustomElement = defineCustomElement$1;

export { ClDatePicker, defineCustomElement };

//# sourceMappingURL=cl-date-picker.js.map